import axios from 'axios';
import { toDate } from './util';

let host = window.location.host;

//checks to see if url starts with "admin."
if (/^admin\./.test(host)) {
    host = host.substring(6, host.length);
}

const APP_ROOT = `${window.location.origin}`;
const API_ROOT = process.env.REACT_APP_API_ROOT || `${APP_ROOT}/api`;

const api = axios.create({
    baseURL: API_ROOT,
    transformResponse: [
        function (data) {
            if (typeof data === 'string' && data !== '') {
                try {
                    data = JSON.parse(data, (key, value) => {
                        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
                            return toDate(value);
                        }

                        return value;
                    });
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e);
                }
            }

            return data;
        },
    ],
});

export default api;

function requestConfig(authToken, params) {
    params = params ?? {};

    return authToken ? { ...params, headers: { ...params.headers, Authorization: `Bearer ${authToken}` } } : params;
}

export const apiGet = async (resource, authToken, params) => {
    try {
        return await api.get(resource, requestConfig(authToken, params));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);

        throw e;
    }
};

export const apiPost = async (resource, data, authToken) => {
    if (!data.id) {
        try {
            return await api.post(resource, data, requestConfig(authToken));
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            throw e;
        }
    } else {
        try {
            return await api.put(`${resource}/${data.id}`, data, requestConfig(authToken));
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            throw e;
        }
    }
};

export const apiPatch = async (resource, data, authToken) => {
    try {
        return await api.patch(resource, data, requestConfig(authToken));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        throw e;
    }
};

export const apiPut = async (resource, data, authToken) => {
    try {
        return await api.put(resource, data, requestConfig(authToken));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        throw e;
    }
};

export const apiDelete = async (resource, authToken) => {
    try {
        return await api.delete(resource, requestConfig(authToken));
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        throw e;
    }
};

export function resourceUrl(path) {
    return `${API_ROOT}/${path}`;
}
